// @ts-strict-ignore
import {EventDropFiltersLimitResults} from 'app_api/projects/data_definitions/types';
import {ApiSingleValueResource} from 'common/util/model-resource/api-resource';

import {dataDropFiltersLimitClient} from '../queries/app-api/data-drop-filters-limit-client';
import {getProjectId} from '../util';

export class DataDropFilterLimitsResource extends ApiSingleValueResource<EventDropFiltersLimitResults> {
  apiClient = dataDropFiltersLimitClient;

  constructor({projectId = null, urlManager = null} = {}) {
    super();
    this.id = projectId ?? getProjectId(urlManager);
  }
}
